export class UndoRedoStack<T> {
    private _undoStack: T[] = [];
    private _undoEventStack: T[] = [];

    private _redoStack: T[] = [];
    private _redoEventStack: T[] = [];


    public getEventToUndo = () => {
        const undoEvent = this._undoStack.pop();
        const redoEvent = this._undoEventStack.pop();
        if (undoEvent === undefined || redoEvent === undefined) return undefined;

        this._redoStack.push(redoEvent);
        this._redoEventStack.push(undoEvent);

        return undoEvent;
    }

    public getEventToRedo = () => {
        const redoEvent = this._redoStack.pop();
        const undoEvent = this._redoEventStack.pop();

        if (redoEvent === undefined || undoEvent === undefined) return undefined;

        this._undoStack.push(undoEvent);
        this._undoEventStack.push(redoEvent);

        return redoEvent;
    }

    public addEventIntoUndoStack = (event: T, undoEvent: T) => {
        //We have a genuine, new user event. Add it to the undo stack
        this._undoStack.push(undoEvent);
        this._undoEventStack.push(event);

        //Clear redo stack
        this._redoStack = [];
        this._redoEventStack = [];
    }
    get hasUndo(): boolean { return this._undoStack.length > 0 }
    get hasRedo(): boolean { return this._redoStack.length > 0 }
}